/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { FunnelChart } from 'react-funnel-pipeline';
import 'react-funnel-pipeline/dist/index.css';
import { ChartContainer, Icon } from './styles';

export interface GraphProps {
  data: { name: string; values: number[] }[];
}

function formatarNumeroBrasileiro(numero: number): string {
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(numero);
}

export function FunnelChartComponent({ data }: GraphProps) {
  const pallete = ['#f14c14', '#f39c35', '#68BC00', '#1d7b63', '#4e97a8', '#4466a3', '#00bfff', '#f4a460', '#b22222'];

  const generateTooltip = (row: any) => {
    return row.tooltip;
  };

  const dataGraph = (data || []).map((item, index) => {
    if (index + 1 < data.length) {
      const processosFaseSeguinte = data[index + 1].values[0];
      return {
        name: item.name,
        key: `${item.name}-${index}`,
        value: item.values[0],
        tooltip:
          `Fase - ${item.name}: ${formatarNumeroBrasileiro(data[index].values[0] as number)} processos\n` +
          `Processos autorizados para a fase seguinte: ${formatarNumeroBrasileiro(
            processosFaseSeguinte as number,
          )} (${formatarNumeroBrasileiro(data[index].values[1] as number)}%)\n` +
          `Processos na fase "Concessão de Lavra" em relação a fase atual: ${formatarNumeroBrasileiro(
            data[index].values[3] as number,
          )} (${formatarNumeroBrasileiro(data[index].values[2] as number)}%)`,
      };
    } else {
      return {
        name: item.name,
        key: `${item.name}-${index}`,
        value: item.values[0],
        tooltip: `Fase - ${item.name}: ${formatarNumeroBrasileiro(data[index].values[0] as number)} processos`,
      };
    }
  });

  return (
    <ChartContainer>
      <div style={{ flex: 1 }}>
        <FunnelChart
          data={dataGraph}
          pallette={pallete}
          getToolTip={(row: any) => generateTooltip(row)}
          decorateValue={(row, index) => {
            return `${formatarNumeroBrasileiro(data[index].values[0] as number)}`;
          }}
        />
      </div>
      <div className="legenda">
        <h3>Legenda</h3>
        <ul className="lista">
          {data.map((item, index) => (
            <li key={`item-${index}-${item.name}`} className="elemento">
              <Icon color={pallete[index]} />
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </ChartContainer>
  );
}
